export default __webpack_public_path__ + "static/section_6_details_2-b4869e31d826c4ba9da292147a630714.png";